import { render } from "./DbPermissionSettings.vue?vue&type=template&id=03e40d13"
import script from "./DbPermissionSettings.vue?vue&type=script&lang=js"
export * from "./DbPermissionSettings.vue?vue&type=script&lang=js"

import "./DbPermissionSettings.vue?vue&type=style&index=0&id=03e40d13&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__